const API_IMAGE_URL = `${window.location.protocol}//${window.location.hostname}`;

export default API_IMAGE_URL;
